import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "../client";

/**
 * Patches a customer's go-live fields. Either key can be null to clear, or
 * omitted to leave untouched. Backend fires a 'go_live_override' timeline
 * event + triggers a health-score recompute on success.
 */
export interface UpdateGoLiveDto {
  dashboardUnlockedAt?: string | null;
  shouldPushPricesEnabledAt?: string | null;
}

export function useUpdateGoLive(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: UpdateGoLiveDto) =>
      client
        .patch(`/admin/customers/${customerId}/go-live`, dto)
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["crm", "customer360", customerId] });
      qc.invalidateQueries({ queryKey: ["crm", "customers"] });
    },
  });
}
